<template>
  <div>
    <v-card-text>
      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div class="auth-form--wrap-col w-100">
          <div class="input-label product-label">
            <div>Наименование / Артикул</div>
            <div
              v-if="showRemove"
              class="product-label-remove"
              @click="$emit('remove')"
            >
              X
            </div>
          </div>
          <v-autocomplete
            v-model="position.product_id"
            :clearable="true"
            :disabled="!isEditable"
            :items="items"
            :loading="loading"
            :open-on-clear="true"
            :rules="[rules.required]"
            :search-input.sync="searchModel"
            class="plcolor custom-autocomplete"
            dense
            hide-details
            hide-no-data
            item-text="name"
            item-value="id"
            no-filter
            placeholder="Начните вводить наименование или артикул"
            required
            solo
          />
        </div>
        <!--        <div class="auth-form&#45;&#45;wrap-col w60">-->
        <!--          <div class="input-label">Серийный номер</div>-->
        <!--          <v-text-field-->
        <!--              v-model="position.product_id"-->
        <!--              type="text"-->
        <!--              outlined-->
        <!--              dense-->
        <!--              required-->
        <!--              item-text="article"-->
        <!--              item-value="id"-->
        <!--              :rules="[rules.required]"-->
        <!--          />-->
        <!--        </div>-->
      </div>
    </v-card-text>

    <v-card-title class="card-title no-border mb-0">
      Фотографии изделия
    </v-card-title>
    <div class="card--notify-block notify-orange">
      ВНИМАНИЕ! Фото 1 должно быть четкое и контрастное
    </div>

    <v-card-text>
      <div class="d-flex flex-wrap justify-space-between">
        <div class="add-files auth-form--wrap-col w50">
          <photo
            :disabled="!isEditable"
            :max-file-size="5"
            :max-files="1"
            :photo="position.number_photos"
            label="Фото 1"
            @add="(photo) => position.number_photos.push(photo)"
            @delete="(idx) => position.number_photos.splice(idx, 1)"
          />
        </div>
        <div class="add-files auth-form--wrap-col w50">
          <photo
            :disabled="!isEditable"
            :max-file-size="5"
            :max-files="1"
            :photo="position.model_photos"
            label="Фото 2"
            @add="(photo) => position.model_photos.push(photo)"
            @delete="(idx) => position.model_photos.splice(idx, 1)"
          />
        </div>
      </div>
    </v-card-text>
  </div>
</template>

<script>
/* eslint-disable linebreak-style */
import Photo from '../../../../sharedComponents/photo/Photo.vue';

export default {
  name: 'Position',
  props: ['position', 'isEditable', 'action_id', 'loading', 'showRemove'],
  components: { Photo },
  data() {
    return {
      items: [],
      searchModel: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  watch: {
    /** Вотчер для автокомплита городов */
    searchModel(val) {
      if (val && !this.items.find(el => el.name === val)) {
        this.getProducts(val);
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getProducts(val) {
      this.$store.getters.axl
        .post('sales/api/product/get-products', {
          search: val,
          action_id: this.action_id,
          profile_id: this.user.profile_id,
        })
        .then((result) => {
          this.items = result.data.items;
        });
    },
  },
  mounted() {
    this.position.product && this.items.push(this.position.product);
  },
};
</script>

<style lang="scss" scoped>
.product-label {
  display: flex;
  justify-content: space-between;
  &-remove {
    margin-right: 15px;
    font-weight: bold;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
